const variantElements = document.querySelectorAll('.variantItem');
const variantNameSpan = document.querySelector('.variant-name');
const galleryImage = document.querySelector('.gallery-image');

let originalVariantName = variantNameSpan.textContent;
let originalGalleryImageSrcset = galleryImage?.srcset ?? '';
let originalGalleryImageSrc = galleryImage?.src ?? '';
let codeEnabled = true;
let hoverToken = 0; // used to know if we're still hovered on same thing

variantElements.forEach((variantElement) => {
  variantElement.addEventListener('mouseover', () => {
    if (!codeEnabled) return;

    hoverToken++; // new hover session
    const thisToken = hoverToken;

    // Update label
    variantNameSpan.textContent = variantElement.getAttribute('data-name');

    const variantImage = variantElement.querySelector('.variant-image');
    if (!variantImage) return;

    // LQ is the thumbnail src (already loaded)
    const lowSrc = variantImage.getAttribute('src');
    // HQ is what you were already using
    const highSrc = variantImage.getAttribute('data-fullsize-src');

    if (!galleryImage) return;

    // 1️⃣ Immediately show LQ on the main image only (no network)
    galleryImage.src = lowSrc;
    galleryImage.srcset = lowSrc;

    // 2️⃣ Preload HQ, then swap once it's ready — but only if still hovered
    const preload = new Image();
    preload.src = highSrc;
    preload.onload = () => {
      if (thisToken !== hoverToken) return; // user moved off / to another variant

      galleryImage.src = highSrc;
      galleryImage.srcset = highSrc;
    };
  });

  variantElement.addEventListener('mouseout', () => {
    if (!codeEnabled) return;

    hoverToken++; // invalidate any pending HQ swap

    // Restore text
    variantNameSpan.textContent = originalVariantName;

    // Restore original main gallery image
    if (galleryImage) {
      if (originalGalleryImageSrc) {
        galleryImage.src = originalGalleryImageSrc;
      }
      if (originalGalleryImageSrcset) {
        galleryImage.srcset = originalGalleryImageSrcset;
      }
    }
  });
});

const ratingBadge = document.querySelector('.rating-badge');
if (ratingBadge) {
  ratingBadge.addEventListener('click', () => {
    codeEnabled = false;
    setTimeout(() => {
      codeEnabled = true;
    }, 4000);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const targetElement = document.querySelector('.variantItem.current');
  const container = document.querySelector('.variant-picker__options');

  if (targetElement && container) {
    const scrollOffset = 0;
    const scrollPosition = targetElement.offsetLeft - container.offsetLeft - scrollOffset;
    container.scrollLeft = scrollPosition;
  }
});